<div class="modal-overlay" *ngIf="isOpen" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Close button -->
    <button class="close-button" (click)="onClose()">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 5L5 15M5 5L15 15" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>

    <!-- Image section -->
    <div class="image-section">
      <div class="illustration-container">
        <img src="/assets/images/sucess_img.svg" alt="Order cancelled successfully" class="success-image">
      </div>
    </div>

    <!-- Text section -->
    <div class="text-section">
      <h2 class="modal-title">Order Canceled!</h2>
      <p class="modal-description" *ngIf="isScheduledOrder">
        A refund of {{ refundAmount }} has been initiated and will be credited to the customer's original payment method in 5-7 business days.
      </p>
      <p class="modal-description" *ngIf="!isScheduledOrder">
        Your order has been canceled successfully.
      </p>
    </div>

    <!-- Bottom section -->
    <div class="bottom-section">
      <div class="button-container">
        <button class="okay-button" (click)="onClose()">
          Okay
        </button>
        <!-- <button class="book-again-button" (click)="onBookAgain()">
          Book again
        </button> -->
      </div>
    </div>
  </div>
</div>
